import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SessionContext } from "../../../context/sessionContext";
import { Modal } from "reactstrap";
import { getStudentList } from "../../../actions/school_user/StudentRegistration";
import Pagination from "react-js-pagination";
import { convertDate } from "../../CommonComponent/DateFormatUtil";
import {
  CustomModalBody,
  CustomModalHeader,
} from "../../CommonComponent/modelComponent";
import Loader from "../../Loader/Loader";
const ForRegularReciptSearch = (props) => {
  const {
    setstudent_uid,
    stu_session,
    setStudent,
    callFrom,
    setDisabledAll,
    setReceiptType,
  } = props;
  const token = localStorage.getItem("token");
  const school_user = JSON.parse(localStorage.getItem("school_user"));
  const { id, user_type, name, user_detail } = school_user;
  let s_id = user_detail?.fk_school_id;
  const { Session } = useContext(SessionContext);
  let session_id = Session || sessionStorage.getItem("SessionId");
  const { studentdata } = useSelector((state) => state.studentRegistration);
  const { academicStudentList } = useSelector(
    (state) => state.getAcademicFilterStudentList
  );

  const [CurrentPage, setCurrentPage] = useState(1);
  const [Page, setPage] = useState(1);
  const resultPerPage = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [idQuery, setIdQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [debouncedIdQuery, setDebouncedIdQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [isPageLoading, setisPageLoading] = useState(false);

  const [noResultsMessage, setNoResultsMessage] = useState("");
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  //   const [search, setSearch] = useState("")
  const toggle = () => {
    setModal(!modal);
    // setSearchResults([]);
    setNoResultsMessage("");
    setCurrentPage(1);
    setIdQuery("");
    setSearchQuery("");
    fetchData()
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedIdQuery(idQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [idQuery]);

  // Debounce for searchQuery
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  const handleInputChangeSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };
  const handleIdInputChange = (e) => {
    setReceiptType("New");
    const query = e.target.value;
    setIdQuery(query);
  };
  const handleSearch = () => {
    let filteredResults;
    filteredResults = studentdata?.payload?.filter(
      (item) =>
        item.std_name?.toLowerCase().includes(searchQuery?.toLowerCase()) &&
        item.student_code?.toString().includes(idQuery)
    );
    setSearchResults(filteredResults);
    setSearchQuery("");
    setIdQuery("");
    if (filteredResults?.length === 0) {
      setNoResultsMessage("No results found.");
    } else {
      setNoResultsMessage("");
    }
  };

  const fetchData = async () => {
    let body = {
      fk_academic: session_id,
      school_id: s_id,
      student_name: searchQuery,
      student_code: idQuery,
      page: CurrentPage,
      status_type: "Admitted",
    };

    setisPageLoading(true);
    try {
      if (token) {
        const res = await dispatch(getStudentList(token, body));
        setSearchResults(res.payload);
        setPage(res.totalRecordCount);
        // handleSearch()
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setisPageLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [dispatch, token, session_id, s_id, CurrentPage]);

  const handleStudentEdit = (data) => {
    setstudent_uid(data?.student_code);
    setReceiptType("New");
    {
      callFrom === "RoomAllotment" && setStudent(data);
    }
    setModal(!modal);
  };

  useEffect(() => {
    setSearchResults(studentdata?.payload);
  }, [studentdata]);


  const OnPageChange = (e) => {
    setCurrentPage(e);
    setIdQuery("");
    setSearchQuery("");
  }

  // useEffect(() => {
  //   handleSearch();
  // }, [studentdata]);

  return (
    <>
      <div className="input-group-append">
        <button
          className="btn btn-outline-secondary"
          data-toggle="tooltip"
          data-placement="top"
          title="View Student List"
          type="button"
          onClick={() => {
            // setSearch(stuList);
            toggle();
          }}
        >
          <i className="fa fa-search"> </i>
        </button>
      </div>

      <Modal
        isOpen={modal}
        toggle={toggle}
        fullscreen
        className="mobel_box"
        backdrop="static"
        keyboard={false}
      >
        <CustomModalHeader toggle={toggle}>
          <div className="row">
            <div className="col-lg-5 col-md-5 my-1">
              <input
                name="code"
                type="text"
                className="form-control"
                placeholder="Student code"
                value={idQuery}
                onChange={handleIdInputChange}
                autoComplete="off"
              />
            </div>
            <div className="col-lg-5 col-md-5 my-1">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Student Name"
                value={searchQuery}
                onChange={handleInputChangeSearch}
                autoComplete="off"
              />
            </div>
            <div className="col-md-2 col-lg-2 my-1">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={()=>fetchData()}
              >
                Search
              </button>
            </div>
          </div>
        </CustomModalHeader>
        {isPageLoading ? (
          <Loader />
        ) : (
          <CustomModalBody noResultsMessage={noResultsMessage}>
            <thead>
              <tr className="text-center">
                <th>Registration Date</th>
                <th>Stud Code.</th>
                <th>Roll no</th>
                <th>Student Name</th>
                <th>Class section</th>
                <th>Gender</th>
                {/* <th>DOB</th> */}
                {/* <th>Category</th> */}
                {/* <th>Caste</th> */}
                {/* <th>Sub Caste</th> */}
                <th>Student Status</th>
                {/* <th>Enrollment No</th> */}
                <th>concession</th>
                <th>Academic Session</th>
              </tr>
            </thead>
            <tbody>
              {searchResults?.map((stu, index) => (
                <tr
                  key={index}
                  className="text-center"
                  onClick={() => handleStudentEdit(stu)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{convertDate(stu.registration_date)}</td>
                  <td>{stu.student_code}</td>
                  <td>{stu.roll_no}</td>
                  <td className="text-left">{stu.std_name}</td>
                  <td>{stu.class_section}</td>
                  <td>{stu.gender}</td>
                  {/* <td>{convertDate(stu.date_of_birth)}</td> */}
                  {/* <td>{stu.fk_category_name}</td> */}
                  {/* <td>{stu.fk_caste_name}</td> */}
                  {/* <td>{stu.sub_caste}</td> */}
                  <td>{stu.student_status}</td>
                  <td>{stu.concession}</td>
                  <td>{stu?.academic_year}</td>
                </tr>
              ))}
            </tbody>
          </CustomModalBody>
        )}

        <ul className="pagination justify-content-center">
          {Page && (
            <Pagination
              activePage={CurrentPage}
              itemsCountPerPage={resultPerPage}
              totalItemsCount={Page}
              hideFirstLastPages={false}
              onChange={(e)=> OnPageChange(e)}
              nextPageText="Next"
              prevPageText="Previous"
              lastPageText="Last"
              firstPageText="1st"
              itemClass="page-item"
              linkClass="page-link"
              activeClass="active"
              activeLinkClass="active"
              hideDisabled={false}
            />
          )}
        </ul>
        {/* <ModalFooter></ModalFooter> */}
      </Modal>
    </>
  );
};

export default ForRegularReciptSearch;
